import React, { Component } from 'react';
import { connect } from "react-redux";

import { Route, Switch } from 'react-router-dom'
import '../style.css';
import { logout } from "../actions/auth";
import DetailPage from './Detail/DetailPage';
import MainPage from './Main/MainPage';


class App extends Component {

  logOut = () => {
    this.props.logout()
  }

  render() {

    if (!this.props.group && this.props.username !== 'admin') {
      return (
        <main id='main'>
          <div className="container">
            <h1>AccessDenied</h1>
            <a className="user__logout btn waves-effect waves-light" onClick={this.logOut}>Повренутися
                          <i className="material-icons right">arrow_back</i>
            </a>
          </div>
        </main>
      )
    }

    return (

      <div className="body">
        <Switch>
          <Route path="/tickets/:id" component={DetailPage} exact />
          <Route path="/" component={MainPage} exact />
          <Route path="*" render={NotFound} />
        </Switch>

        {/*<Footer/>*/}
      </div>

    );
  }
}

function NotFound() {
  return (
    <main id='main'>
      <div className="container">
        <h1>Not Found</h1>
      </div>
    </main>
  )
}

const mapStateToProps = (state) => {
  return {
    username: state.auth.username,
    group: state.auth.groups['0'],

  };
};

const mapDispatchToProps = (dispatch) => {

  return {
    logout: () => dispatch(logout()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/components/App.js